import { Box, type CircularProgressProps, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import type { JSX } from 'react'

const CircularProgressWithLabel = ({
  id,
  ...rest
}: CircularProgressProps & { value: number; id: string }): JSX.Element => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress aria-labelledby={id} variant="determinate" {...rest} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" id={id}>
          {`${Math.round(rest.value ?? 0)}%`}
        </Typography>
      </Box>
    </Box>
  )
}

export default CircularProgressWithLabel
